/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useEffect } from 'react';
import { Input, message, Modal } from 'antd';
import { useIntl } from 'react-intl';
import { ModalProps } from 'antd/lib/modal';

import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import { appLog } from '~src/utils/log';
import { queryCache, useMutation } from 'react-query';
import { QueryKeys } from '~src/hooks/api-hooks/queryKeys';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import { editShare } from '~src/services/api/shares';
import { Controller, useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface LogTabProps {
  loading: boolean;
  onCancel?: () => void;
  projectId: number;
  tenderId: number;
  shareKey: string;
  emailDisabled?: boolean;
  status: number;
  detailLog: any;
  previousData?: {
    name: string;
    http: string;
    phone: string;
    email?: string;
    note?: string;
    offers?: Array<{
      state: number;
      contract_id?: number;
      is_offer_created?: boolean;
      offer_id?: number;
    }>;
  };
}

export const LogTab: React.FC<LogTabProps> = ({
  onCancel,
  projectId,
  tenderId,
  shareKey,
  status,
  detailLog,
  previousData,
  ...modalProps
}) => {
  const intl = useIntl();
  const styles = useStyles(styleFn);

  appLog(`LOGS`, detailLog);

  const statusCalc = (type: number) => {
    switch (type) {
      case 1:
        return {
          color: 'orange',
          text: 'Resent invitation',
          icon: <FontAwesomeIcon icon={['far', 'envelope']} />,
        };
      case 4:
        return {
          color: 'blue',
          text: 'Invitation opened',
          icon: <FontAwesomeIcon icon={['far', 'envelope-open-text']} />,
        };
      case 3:
        return {
          color: 'green',
          text: 'Claimed sharekey as',
          icon: <FontAwesomeIcon icon={['far', 'check-circle']} />,
        };
      case 5:
        return {
          color: 'red',
          text: 'Rejected',
          icon: <FontAwesomeIcon icon={['fas', 'ban']} />,
        };
      default:
        return {
          color: 'black',
          text: 'Awaiting',
          icon: <FontAwesomeIcon icon={['far', 'stopwatch']} />,
        };
    }
  };

  const formatDate = (date: Date): string => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}`;
  };

  return (
    <div css={styles.formContainer}>
      <div>
        <h3>Log</h3>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {detailLog && detailLog.length > 0 ? (
          detailLog.map((log, index) => {
            const { color, text, icon } = statusCalc(log.type);
            const logDate = formatDate(new Date(log.created_at * 1000));
            return (
              <div css={styles.formUpper}>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <div style={{ color: `${color}`, fontSize: 24 }}>{icon}</div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ fontSize: '12px', color: 'grey' }}>
                      {logDate}
                    </div>
                    <div style={{ marginTop: '-2px' }}>{text}</div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div>No logs available</div>
        )}
      </div>
    </div>
  );
};

export const styleFn: ThemedStyleFn = (theme) => ({
  // Form
  formContainer: {
    margin: 10,
  },
  formUpper: {
    // backgroundColor: 'red',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  formStatus: {
    // backgroundColor: 'blue',
    display: 'flex',
    gap: '120px',
  },
  formAcceptedAs: {
    display: 'flex',
    gap: '30px',
    height: '100px',
  },
  formAcceptedDetails: {
    display: 'flex',
    flexDirection: 'column',
    color: 'gray',
  },
  buttonsBlock: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 10,
  },
  leftButton: {
    marginRight: 10,
  },
  formItem: {
    marginBottom: 12,
  },
  formLabel: {
    marginBottom: 12,
  },
  cardContainer: {
    marginTop: 10,
    borderRadius: 10,
  },
  dateText: {
    textAlign: 'start',
    fontSize: 12,
    paddingRight: 8,
  },
  mergeContainer: {
    display: 'flex',
  },
  twoColumnsField: {
    width: '50%',
    margin: '4px 0px 15px -1px',
  },
});
